import { makeStyles } from "tss-react/mui";
import { MiFileUpload, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_LABELS,
  BUTTON_VARIANTS,
  VALID_BID_DOCUMENT_FILE_MIME_TYPES,
} from "@miplatform/constants";
import { mdiFileDocumentOutline } from "@mdi/js";
import { Box, TextField } from "@mui/material";
import { DocCategory } from "../../Bids/CreateBid/CreateBids.types";
import { DOC_CATEGORY } from "../../Bids/CreateBid/constants";

export function UploadDocumentModal({
  open,
  docCategory,
  documentLabel,
  selectedFile,
  loading,
  handleCloseUploadModal,
  handleUploadFile,
  setDocumentLabel,
  setSelectedFile,
}: UploadDocumentModalProps) {
  const { classes } = useStyles();

  return (
    <MiModal
      open={open}
      title="Upload File"
      titleIcon={mdiFileDocumentOutline}
      description="Enter information for the document"
      closeModal={handleCloseUploadModal}
      actions={[
        {
          name: BUTTON_LABELS.CANCEL,
          color: BUTTON_COLORS.BLACK,
          onClick: handleCloseUploadModal,
        },
        {
          name: "Upload File",
          variant: BUTTON_VARIANTS.CONTAINED,
          color: BUTTON_COLORS.PRIMARY,
          onClick: handleUploadFile,
          disabled: !selectedFile || !documentLabel || loading,
        },
      ]}
    >
      <Box className={classes.uploadModalBox}>
        <TextField
          label="Document Label"
          value={documentLabel}
          onChange={(e) => setDocumentLabel(e.target.value)}
          required
          size="small"
          fullWidth
          disabled={
            docCategory === DOC_CATEGORY.PLAN ||
            docCategory === DOC_CATEGORY.SPEC
          }
        />
        <MiFileUpload
          onChange={(files: FileList) => setSelectedFile(files[0])}
          dragAndDrop
          multiple={false}
          acceptableFormatText="Acceptable formats: pdf, xlsx, xls, csv, docx, doc, jpeg, jpg, png, webp"
          acceptFiles={VALID_BID_DOCUMENT_FILE_MIME_TYPES.join(",")}
        />
      </Box>
    </MiModal>
  );
}

const useStyles = makeStyles()((theme) => ({
  uploadModalBox: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

interface UploadDocumentModalProps {
  open: boolean;
  docCategory: DocCategory | null;
  documentLabel: string;
  selectedFile: File | null;
  loading: boolean;
  handleCloseUploadModal: () => void;
  handleUploadFile: () => void;
  setDocumentLabel: (value: string) => void;
  setSelectedFile: (file: File | null) => void;
}
